import { inject, watch } from 'vue';
import { REPORTS_SHELL_PERIOD } from '../helpers/reportsPeriod';

/**
 * Para a tela embutida: devolve o periodo da casca (ou null fora da casa) e
 * chama `apply(periodo)` a cada troca. A chave primitiva evita refazer a busca
 * quando a URL muda por outro motivo (filtro de caixa, agrupamento).
 */
export function useShellPeriod(apply, { immediate = false } = {}) {
  const shell = inject(REPORTS_SHELL_PERIOD, null);
  if (shell && apply) {
    watch(
      () => shell.periodKey.value,
      () => apply(shell.period.value),
      { immediate }
    );
  }
  return shell;
}
